import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [60, null, 150],
    background: 'transparent',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    height: [44, null, 56],
    background: '#fff',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
  })),
  logo: css(mq({
    display: 'block',
  })),
  logoImg: css(mq({
    transition: 'all 0.3s',
    display: 'block',
    height: [60, null, 120],
    width: 'auto',
    // mobile: leave room for the cart + hamburger buttons (88px) on each side
    maxWidth: ['calc(100vw - 184px)', null, '60vw'],
    objectFit: 'contain',
  })),
  logoScrolled: css(mq({

  })),
  logoImgScrolled: css(mq({
    transition: 'all 0.3s',
    display: 'block',
    height: [38, null, 50],
    width: 'auto',
    // mobile: leave room for the cart + hamburger buttons (88px) on each side
    maxWidth: ['calc(100vw - 184px)', null, '60vw'],
    objectFit: 'contain',
  })),
}
